import classNames from 'classnames';
import { ProductCarouselItem } from '../interface';
import * as styles from './ProductItem.module.scss';

export const ProductItem = ({
  title,
  description,
  price,
  promotion,
  onClick,
  imageUrl,
  subtitleBold,
}: ProductCarouselItem & { subtitleBold?: boolean }) => {
  const subtileStyles = classNames(styles.subtitle, {
    [styles.subtitleBold]: subtitleBold,
  });

  return (
    <div className={styles.item}>
      {onClick && <button className={styles.clickableArea} onClick={onClick} aria-hidden="true" />}
      <img className={styles.image} alt={title} src={imageUrl} />
      <div className={styles.title}>{title}</div>
      {description && <p className={subtileStyles}>{description}</p>}
      {price && <p className={styles.price}>Comp Value: ${price}</p>}
      {promotion && <p className={styles.promotion}>{promotion}</p>}
    </div>
  );
};
